import { createFileRoute } from '@tanstack/react-router';
import Experiences from '~/containers/Experiences';

export const Route = createFileRoute('/experiences/')({
  component: Experiences,
});
